// extracted by mini-css-extract-plugin
export var dropOver = "_ix-2";
export var dropValid = "_ix-1";
export var hidden = "_ix-3";
export var line = "_ix-0";